import { Column } from 'primereact/column'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { Group } from '@mantine/core'
import Button from '../../../components/common/buttons'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import { bodyParseDate } from '../../../components/common/data-table/column-types/ColumnTypes'
import CheckboxCom from '../../../components/common/form-components/checkbox/CheckboxComp'
import { NeedsService } from '../../../services/purchase-fuel/needs/needs.service'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import './purchaseNeeds.scss'
import swalAlert from '../../../utils/helpers/swalAlert'
import { formatNumber } from '../../../utils/helpers/common'
import AppSection from '../../../component/layout/AppSection.tsx'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import AppRangePicker from '../../../component/form/AppRangePicker.tsx'
import useAccess from '../../../utils/hooks/useAccess.js'
import { DataTableFun } from '../../../utils/helpers/dataTableFun.js'

const FIELD_KEYS = {
  CENTER_NAME: 'centerName',
  DOWNLOAD_DATE: 'downloadDate',
  QUANTITY_GOA: 'quantityGOA',
  QUANTITY_GOAPLUS: 'quantityGOAPLUS',
  QUANTITY_G95: 'quantityG95',
  SELECTED_ITEMS: 'selectedItems',
}

const Needs = () => {
  const { formatMessage: msg } = useIntl()
  const [areAllNeedsSelected, setAreAllNeedsSelected] = useState(false)

  const { canDelete } = useAccess()

  const [selectedDateRange, setSelectedDateRange] = useState([
    undefined,
    undefined,
  ])

  const editIfToCard = (data) => {
    NeedsService.updateNeed({ needId: data?._id, elementId: data?.body })
  }
  const addToCart = async () => {
    const needsIds = dataFacade?.data?.resp.map((item) => item?._id)
    const resp = await NeedsService.addToCart({ list: needsIds })
    if (resp) {
      setAreAllNeedsSelected(false)
      dataFacade.reload()
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: FIELD_KEYS.CENTER_NAME,
    getAll: NeedsService.getAll,
    removeAction: NeedsService.remove,
    editAction: editIfToCard,
    createAction: addToCart,
    rowsPerPageInitial: 100,
  })

  const customFormatDate = (date) => {
    return new Date(date).toISOString()
  }

  const createNeeds = async (e) => {
    if (selectedDateRange[0]) {
      const swal = swalAlert.loadinng(msg({ id: 'swal.title.loading' }))
      // const resp = await NeedsService.createNeeds({initDate: customFormatDate(startDate), endDate: customFormatDate(endDate)})
      const resp = await NeedsService.createNeeds({
        initDate: customFormatDate(selectedDateRange[0]),
        endDate: customFormatDate(selectedDateRange[1]),
      })
      if (resp) {
        setAreAllNeedsSelected(false)
        swal.close()
        dataFacade?.reload()
      }
    }
  }

  // useEffect(() => {
  //     selectAllNeeds()
  // }, [dataFacade?.data?.resp])

  const headerOptions = {
    title: (
      <Group w="400px">
        <AppRangePicker
          w="300px"
          value={selectedDateRange}
          onChange={setSelectedDateRange}
          clearable
        />
        <div className="p-search">
          <Button
            isDisabled={!selectedDateRange[0] && !selectedDateRange[1]}
            iconClass="pi pi-plus"
            btnText={msg({ id: 'create' })}
            iconRight
            btnClass="btn btn__bg-orange"
            onHandleClick={createNeeds}
          />
        </div>
      </Group>
    ),
    handlerHeaderActions: {
      secondaryButton: addToCart,
      secondaryButtonText: 'button.add.to.cart',
      secondaryButtonIcon: 'pi-plus',
    },
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const editCheckbox = (rowData) => {
    if (!rowData.error) {
      return (
        <CheckboxCom
          onChange={async () => {
            const resp = await NeedsService.updateNeed({
              needId: rowData?._id,
              elementId: rowData?.purchaseId,
            })
            if (resp) {
              dataFacade.reload()
            }
          }}
          checked={rowData?.addToCart}
        />
      )
    }
    return rowData.error
  }

  const selectAllNeedsCheckbox = (
    <CheckboxCom
      onChange={async () => {
        if (areAllNeedsSelected) {
          const resp = await NeedsService.desactivateAll(
            dataFacade?.data?.resp?.[0]?.needId,
          )
          if (resp) setAreAllNeedsSelected(false)
        } else {
          const resp = await NeedsService.activateAll(
            dataFacade?.data?.resp?.[0]?.needId,
          )
          if (resp) setAreAllNeedsSelected(true)
        }
        dataFacade.reload()
      }}
      checked={areAllNeedsSelected}
    />
  )

  const selectedItemsHeader = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {msg({ id: 'selected' })}&nbsp;&nbsp;{selectAllNeedsCheckbox}
      &nbsp;&nbsp;
    </div>
  )

  const formatQuantity = (rowData, field, extraField) =>
    rowData && (
      <span className="revealOnHover">
        <span>
          {rowData[field] && (
            <ul className="contentToReveal">
              <li>
                {msg({ id: 'dailyConsumption' })}:&nbsp;&nbsp;
                {formatNumber(rowData[extraField]?.dailyConsumption)}
              </li>
              <li>
                {msg({ id: 'initialQuantityTank' })}:&nbsp;&nbsp;
                {formatNumber(rowData[extraField]?.initialQuantityTank)}
              </li>
              <li>
                {msg({ id: 'capacityTank' })}:&nbsp;&nbsp;
                {formatNumber(rowData[extraField]?.capacityTank)}
              </li>
            </ul>
          )}
        </span>
        <span>
          {rowData[field] && (
            <>
              {String(rowData[field])}
              <span style={{ opacity: 0.6, fontSize: '90%' }}>{' /m³'}</span>
            </>
          )}
        </span>
      </span>
    )

  const data = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        ...dataFacade?.sortOptions,
        // scrollable: true,
        // scrollHeight: DataTableFun.responsiveHeight(dataTablePaddingBottom),
        rowGroupMode: 'rowspan',
        groupRowsBy: 'centerName',
        selectionMode: 'checkbox',
      }}
      columns={[
        <Column
          key={FIELD_KEYS.CENTER_NAME}
          field={FIELD_KEYS.CENTER_NAME}
          header={msg({ id: 'center' })}
          style={{ width: 160, minWidth: 160 }}
        />,
        <Column
          key={FIELD_KEYS.DOWNLOAD_DATE}
          field={FIELD_KEYS.DOWNLOAD_DATE}
          header={msg({ id: 'date.download' })}
          body={(rowData) => bodyParseDate({ date: rowData?.downloadDate })}
          style={{ width: 120, minWidth: 120 }}
        />,
        <Column
          key={FIELD_KEYS.QUANTITY_GOA}
          field={FIELD_KEYS.QUANTITY_GOA}
          header={msg({ id: 'quantity.GOA' })}
          alignHeader="right"
          align="right"
          className="revealOnHover"
          style={{ textAlign: 'right', width: '20%', maxWidth: '20%' }}
          body={(rowData) => formatQuantity(rowData, 'quantityGOA', 'GOA')}
        />,
        <Column
          key={FIELD_KEYS.QUANTITY_GOAPLUS}
          field={FIELD_KEYS.QUANTITY_GOAPLUS}
          header={msg({ id: 'quantity.GOAPLUS' })}
          alignHeader="right"
          className="revealOnHover"
          style={{ textAlign: 'right', width: '20%', maxWidth: '20%' }}
          body={(rowData) =>
            formatQuantity(rowData, 'quantityGOAPLUS', 'GOAPLUS')
          }
          // body={(rowData) => formatQuantity(JSON.stringify(rowData[FIELD_KEYS.QUANTITY_GOAPLUS]))}
        />,
        <Column
          key={FIELD_KEYS.QUANTITY_G95}
          field={FIELD_KEYS.QUANTITY_G95}
          header={msg({ id: 'quantity.G95' })}
          alignHeader="right"
          className="revealOnHover"
          style={{ textAlign: 'right', width: '20%', maxWidth: '20%' }}
          body={(rowData) => formatQuantity(rowData, 'quantityG95', 'G95')}
          // body={(rowData) => formatQuantity(JSON.stringify(rowData[FIELD_KEYS.QUANTITY_G95]))}
        />,
        <Column
          key={FIELD_KEYS.SELECTED_ITEMS}
          header={selectedItemsHeader}
          alignHeader="right"
          align="right"
          style={{ width: 180, minWidth: 180 }}
          body={(rowData) => editCheckbox(rowData)}
        />,
        canDelete && (
          <Column
            className="row-delete"
            align="right"
            body={(rowData) =>
              DataTableFun.buttonDelete(rowData, dataFacade.remove)
            }
          />
        ),
      ]}
    />
  )

  return (
    <AppSection
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      headerOptions={headerOptions}
    >
      <Group w="100%" className="purchases-needs">
        {data}
      </Group>
    </AppSection>
  )
}

export default Needs
